/**
 * The public legal pages and the privacy policy version a client agrees to at
 * registration (registration-privacy-consent). Zero imports: the webapp reads
 * these through the browser barrel.
 *
 * PRIVACY_POLICY_VERSION is the policy's effective date (docs/legal/privacy-policy.md).
 * Bump it in the same change as a new effective date; stored acceptances keep the
 * version the client actually agreed to.
 */
export const PRIVACY_POLICY_VERSION = '2026-11-02';

/** Paths under the deployed origin; the webapp builds full URLs from its own origin. */
export const LEGAL_PAGE_PATHS = {
  index: '/webapp/legal/',
  privacyPolicy: '/webapp/legal/privacy-policy.html',
  termsOfService: '/webapp/legal/terms-of-service.html',
  betaAgreement: '/webapp/legal/beta-agreement.html',
} as const;
